// 쇼핑몰별 지원 여부 등 호환성 매트릭스 표를 렌더하는 컴포넌트
import classes from './MatrixTable.module.css';

/**
 * 호환성 매트릭스 표.
 * 헤더와 셀은 문서 데이터가 HTML 문자열을 담고 있어 dangerouslySetInnerHTML 로 렌더한다.
 * 셀 하나에 `<code>101</code>: 사유<br/>` 같은 여러 줄이 들어오는 구조를 그대로 옮기기 위함이다.
 *
 * 표를 접어 두는 details/summary 래핑은 이 컴포넌트가 담지 않는다.
 * 문서마다 구조가 달라 호출하는 쪽이 감싼다.
 */
const MatrixTable = ({ intro, headers, rows }) => {
  const headerCells = headers || [];
  const bodyRows = rows || [];
  const bodyCols = bodyRows.reduce((max, row) => Math.max(max, row.length), 0);
  // 헤더가 본문 열 수보다 적으면 마지막 헤더 셀이 남은 열을 덮는다.
  // 표 전체를 설명하는 캡션을 colSpan 헤더로 쓴 문서가 있어서 필요하다
  const lastHeaderSpan = bodyCols > headerCells.length ? bodyCols - headerCells.length + 1 : 1;

  return (
    <div className={classes.container}>
      {intro && (
        <div className={classes.intro} dangerouslySetInnerHTML={{ __html: intro }} />
      )}

      <table className={classes.table}>
        {headerCells.length > 0 && (
          <thead>
            <tr>
              {headerCells.map((cell, i) => (
                <th
                  className={classes.th}
                  key={i}
                  colSpan={i === headerCells.length - 1 ? lastHeaderSpan : 1}
                  dangerouslySetInnerHTML={{ __html: cell }}
                />
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {bodyRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td
                  className={classes.td}
                  key={cellIndex}
                  dangerouslySetInnerHTML={{ __html: cell }}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MatrixTable;
